module.exports = __webpack_public_path__ + "static/media/logo-image.6b37ad21.webp";